import React from "react";
import { View, StyleSheet, Text, TouchableOpacity } from "react-native";

import useStatusBar from "../hooks/useStatusBar";
import { logout } from "../components/Firebase/firebase";
import { Button } from "react-native-elements";
import Ionicons from "@expo/vector-icons/Ionicons";
import { LinearGradient } from "expo-linear-gradient";
import SettingsButton from "./SettingsButton";

export default function Settings(props) {
  useStatusBar("dark-content");
  async function handleSignOut() {
    try {
      await logout();
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <View style={styles.container}>
      {/* <SettingsButton title="Change name" onPress={handleSignOut} />
      <SettingsButton title="Pick an image from camera role" onPress={handleSignOut} />
      <SettingsButton title="Take Photo" onPress={handleSignOut} /> */}
      {/* <SettingsButton title="Change Password" onPress={handleSignOut} /> */}
      <SettingsButton
        title="Terms and conditions"
        onPress={() => {
          props.navigation.navigate("TermsConditions");
        }}
      />

      <SettingsButton title="Sign Out" onPress={handleSignOut} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
